/**
 * event emitter
 * reference: https://github.com/primus/eventemitter3
 */
import EE from 'eventemitter3';

export default new EE();
